module.exports = __webpack_public_path__ + "images/ui-bg_highlight-soft_75_ffe45c_1x100.png";